import { useState } from 'react';
import { useVantifyContext } from 'integrations-vantify-context-providers';
import {
  getServiceProviderPriorities,
  ServiceProviderPriority,
  VantifyQuery,
} from 'integrations-vantify-client-services';
import { useVantifyBase } from '../useVantifyBase';
import { VantifyOperation, hookMessages } from '../common';

export function useVantifyServiceProviderPriorities() {
  const { auth } = useVantifyContext();
  const { loading, error, execute, setError } = useVantifyBase();
  const [serviceProviderPriorities, setServiceProviderPriorities] =
    useState<ServiceProviderPriority[] | null>(null);

  const fetchServiceProviderPriorities = async (
    serviceProviderId: number,
    query?: VantifyQuery
  ) => {
    if (!auth) {
      setError(e => ({
        ...e,
        [VantifyOperation.FETCH_SERVICE_PROVIDER_PRIORITIES]:
          hookMessages.error_FETCH_SERVICE_PROVIDER_PRIORITIES,
      }));

      return null;
    }

    setServiceProviderPriorities(null);

    const response = await execute(
      VantifyOperation.FETCH_SERVICE_PROVIDER_PRIORITIES,
      () => getServiceProviderPriorities(auth, serviceProviderId, query),
      hookMessages.error_FETCH_SERVICE_PROVIDER_PRIORITIES
    );

    if (response?.data?.priorities) {
      setServiceProviderPriorities(response.data.priorities);

      return response.data.priorities;
    }

    return null;
  };

  return {
    serviceProviderPriorities,
    loading,
    error,
    fetchServiceProviderPriorities,
  };
}
